import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { getDelayReport, getReport } from "./index";

export const useReport = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getReport: getReport(customFetch),
      getDelayReport: getDelayReport(customFetch),
    }),
    [customFetch]
  );
};
